import { render, staticRenderFns } from "./AddingRecord.vue?vue&type=template&id=60ee06c8&scoped=true"
import script from "./AddingRecord.vue?vue&type=script&lang=js"
export * from "./AddingRecord.vue?vue&type=script&lang=js"
import style0 from "./AddingRecord.vue?vue&type=style&index=0&id=60ee06c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ee06c8",
  null
  
)

export default component.exports